import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { AuthProvider } from "@/lib/auth-context";
import { AdminShell } from "@/pages/admin/AdminShell";
import Screensaver from "@/pages/Screensaver";
import DownloadPage from "@/pages/DownloadPage";
import DashboardPage from "@/pages/admin/DashboardPage";
import WorkspaceEditorPage from "@/pages/admin/WorkspaceEditorPage";
import SharedGroupsPage from "@/pages/admin/SharedGroupsPage";
import SharedGroupEditorPage from "@/pages/admin/SharedGroupEditorPage";

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          {/* Public kiosk */}
          <Route path="/screensaver/:workspace" element={<Screensaver />} />

          {/* Public download page */}
          <Route path="/download" element={<DownloadPage />} />

          {/* Admin (auth-gated) */}
          <Route
            path="/admin/screensaver"
            element={
              <AdminShell>
                <DashboardPage />
              </AdminShell>
            }
          />
          <Route
            path="/admin/screensaver/:slug"
            element={
              <AdminShell>
                <WorkspaceEditorPage />
              </AdminShell>
            }
          />
          <Route
            path="/admin/shared-groups"
            element={
              <AdminShell>
                <SharedGroupsPage />
              </AdminShell>
            }
          />
          <Route
            path="/admin/shared-groups/:id"
            element={
              <AdminShell>
                <SharedGroupEditorPage />
              </AdminShell>
            }
          />

          <Route path="/admin" element={<Navigate to="/admin/screensaver" replace />} />
          <Route path="/" element={<Navigate to="/admin/screensaver" replace />} />
          <Route path="*" element={<Navigate to="/admin/screensaver" replace />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}
